<template>
  <div ref="xjTable" style="position: relative;background-color: #fff;padding-top: 10px">
  <div id="xj-table" v-loading="outloading">
    <div v-if="!labelData[0].label"  id="headset" :style="{width:(labelData[0].width-20)+'px'}">
      <slot name="headset"></slot>
    </div>
    <el-table
      :data="tableDataFilter"
      :border="false"
      :height="tableHeight"
      :max-height="tableHeight"
      @cell-click="cellClick"
      v-loading="loading"
      @sort-change="sortChange"
      ref="repoptTable"
      :row-class-name="tableRowClassName"
      style="width: 100%">
      <!--第一栏为自定义栏-->
      <el-table-column
        fixed="left"
        :class-name="labelData[0].label?'title-label':''"
        :width="labelData[0].width">
        <template slot="header" slot-scope="scope" v-if="labelData[0].label">
          <span>{{labelData[0].label}}</span>
        </template>
        <el-table-column
          :prop="labelData[0].prop"
          :width="labelData[0].width"
        >
          <template slot="header" slot-scope="scope">
            <slot name="column">
              <div class="reset" @click="resetTable">默认排序</div>
            </slot>
          </template>
          <template slot-scope="scope">
            <div v-if="totalDown">
              <span class="totolerow-index"  v-if="totalDown" :style="{visibility:scope.$index>=tableData.length - totalIsSum?'hidden':'visible'}">{{scope.$index + pageSize}}</span>
              <b class="wb" v-if="totalDown" :class="{'totolerow':scope.$index>=tableData.length - totalIsSum}">{{scope.row[labelData[0].prop]}}</b>
            </div>
            <div v-else>
              <span class="totolerow-index"  :class="[(scope.$index-totalIsSum<3)?('toptotolerow'+(scope.$index-totalIsSum)):'']"  :style="{visibility:scope.$index<totalIsSum?'hidden':'visible'}">{{scope.$index-totalIsSum+1}}</span>
              <b class="wb" :class="{'totolerow':scope.$index<totalIsSum}">{{scope.row[labelData[0].prop]}}</b>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!--后面栏为需要固定列的循环栏-->
      <el-table-column v-if="labelData.length >= 2" v-for="(i,k) of labelData[2]"  :key="k + labelData[1].length" fixed="left" :min-width="i.minWidth"> <!--labelArr里面的所有minWidth的和-->
        <template slot="header" slot-scope="scope">
          <el-tooltip  placement="top-start" popper-class="title-prop" effect="light" v-if="i.tip">
            <div slot="content">{{i.tip}}</div>
            <span>{{i.labelName}}</span>
          </el-tooltip>
          <span v-else>{{i.labelName}}</span>
        </template>
        <el-table-column
                v-for = "(ii,kk) of i.labelArr"
                :key="kk"
                :prop="ii.prop"
                :sort-orders="['ascending', 'descending']"
                :width="ii.width?ii.width:undefined"
                :min-width="ii.minWidth?ii.minWidth:undefined"
                :class-name=" (totalIsSum&&totalDown?'last-row':'')+ ' '+  (totalIsSum&&!totalDown?'first-row':'')+'  '+ 'label-cell'+(k%2)+' '+ ((kk==0)?'label-cell-border':'') +'  ' + (ii.color?'cell-'+ii.color:'') + '  '+ (ii.canClick?'cell-click':'') "
                :sortable="ii.nosortable?false:'custom'"
        >
          <template slot="header" slot-scope="scope">
            <el-tooltip  placement="top-start" effect="light">
              <div slot="content">{{ii.tip?ii.tip:ii.label}}</div>
              <span :class="{'no-sort':ii.nosortable}">{{ii.label}}</span>
            </el-tooltip>
          </template>
          <template  slot-scope="scope">
            <!-- 月度产值计划明细表才使用 -->
            <div v-if="loseHeight==33">
              <el-tooltip v-if="ii.tip=='needTip'"  placement="top-start" effect="light">
                <div slot="content">{{scope.row[ii.prop+'']}}</div>
                <span>{{scope.row[ii.prop+'']}}</span>
              </el-tooltip>
              <span v-else>{{scope.row[ii.prop+'']}}</span>
            </div>
            <div v-else>
              <span v-if="ii.notChange">{{scope.row[ii.prop+'']}}</span>
              <span v-else>{{((scope.row[ii.prop+'']).toString().includes('%')||(scope.row[ii.prop+'']).toString()=='-')?scope.row[ii.prop+'']:Number(scope.row[ii.prop+'']).toFixed(2)}}</span>
            </div>

          </template>

        </el-table-column>
      </el-table-column>
      <!--后面栏为循环栏-->
      <el-table-column v-for="(i,k) of labelData[1]"  :key="k">
        <template slot="header" slot-scope="scope">
          <el-tooltip  placement="top-start" popper-class="title-prop" effect="light" v-if="i.tip">
            <div slot="content">{{i.tip}}</div>
            <span>{{i.labelName}}</span>
          </el-tooltip>
          <span v-else>{{i.labelName}}</span>
        </template>
        <el-table-column
          v-for = "(ii,kk) of i.labelArr"
          :key="kk"
          :prop="ii.prop"
          :sort-orders="['ascending', 'descending']"
          :width="ii.width?ii.width:undefined"
          :min-width="ii.minWidth?ii.minWidth:undefined"
          :class-name=" (totalIsSum&&totalDown?'last-row':'')+ ' '+  (totalIsSum&&!totalDown?'first-row':'')+'  '+ 'label-cell'+(k%2)+' '+ ((kk==0)?'label-cell-border':'') +'  ' + (ii.color?'cell-'+ii.color:'') + '  '+ (ii.canClick?'cell-click':'') "
          :sortable="ii.nosortable?false:'custom'"
        >
          <template slot="header" slot-scope="scope">
            <el-tooltip  placement="top-start" effect="light">
              <div slot="content">{{ii.tip?ii.tip:ii.label}}</div>
               <span :class="{'no-sort':ii.nosortable}">{{ii.label}}</span>
            </el-tooltip>
          </template>
          <template  slot-scope="scope">
            <!-- 月度产值计划明细表才使用 -->
            <div v-if="loseHeight==33">
              <el-tooltip v-if="ii.tip=='needTip'"  placement="top-start" effect="light">
                <div slot="content">{{scope.row[ii.prop+'']}}</div>
                <span>{{scope.row[ii.prop+'']}}</span>
              </el-tooltip>
              <span v-else>{{scope.row[ii.prop+'']}}</span>
            </div>
            <div v-else>
              <pop-show v-if="ii.popShow" :row="scope.row[ii.prop+'']"></pop-show>
              <span v-else-if="ii.notChange">{{scope.row[ii.prop+'']}}</span>
              <span v-else>{{((scope.row[ii.prop+'']).toString().includes('%')||(scope.row[ii.prop+'']).toString()=='-')?scope.row[ii.prop+'']:Number(scope.row[ii.prop+'']).toFixed(2)}}</span>
            </div>

          </template>

        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
    <epagination :total="totalRows" :current="currentPage" @change="getPages" :page-sizes="[25,50,100,200]"
                 v-if="tableData && showChangePage">
    </epagination>
    <slot name="innerBar">

    </slot>
  </div>
</template>

<script>




  export default {
    data(){
      return{
        tableDataFilter:[],
        tableHeight:'calc( 100vh - 200px)',
        outloading:false,
        totalIsSum:0,
      }

    },
    props:{
      sortAll:{
        type:Boolean,
        default:false
      },
      showChangePage:{
        type:Boolean,
        default:false
      },
      totalRows:{
        type:Number,
        default:0
      },
      currentPage:{
        type:Number,
        default:1
      },
      //table列
      labelData:{
        type:Array,
        required:true
      },
      //传入的行的数据
      tableData:{
        type: Array,
        required: true
      },
      specialPath:{
        //根据功能做特殊处理的字段
        type:String
      },
      //loading 效果
      loading:{
        type:Boolean,
        default:false
      },
      //totalSpans 合计的行数
      totalSpans:{
        type:Number,
        default: 0
      },
      totalDown:{
        type:Boolean,
        default:false
      },
      pageSize:{
        type:Number,
        default:1
      },
      //月度产值计划明细表才使用，因为会有分页
      loseHeight:{
        type:Number,
        default:0
      },
      type:''
    },
    watch:{
      tableData(){
        this.filterIsSum()
        this.tableDataFilter=this.tableData

      }
    },
    // computed:{
    //   tableDataFilter(){
    //     if(this.tableData&&this.tableData.length){
    //       return this.tableData
    //     }
    //   }
    // },
   created(){
      this.outloading=true
      this.tableDataFilter=this.tableData
      this.outloading=false
   },

    methods:{
      getPages(page, pageSize) {
        console.log("getPages", page, pageSize)
        this.$emit('getPages', page, pageSize)
      },
      tableRowClassName({row, rowIndex}) {
        // if(!this.specialPath){
          if(this.totalIsSum){
            if(!this.totalDown){
              if(rowIndex<this.totalIsSum){
                return 'table-row-color'
              }
            }else {
              if(rowIndex>=(this.tableData.length-this.totalIsSum)){
                return 'table-row-color'
              }
            }
          }
          return ''
        // }else{
        //   if(row.isSum){
        //     return 'special-table-row-color'
        //   }
        // }

      },
      setAutoHeight(){

          let _this=this
          setTimeout(()=>{
            let offsetTop= this.$refs['xjTable'].offsetTop;
            this.tableHeight = window.innerHeight - offsetTop - 68 -12 - this.loseHeight +'px';
          })
      },
      resetTable(){
        this.outloading=true;
        this.tableDataFilter=this.tableData
        setTimeout(()=>{
          this.$refs['repoptTable'].clearSort();
          this.outloading=false
        },300)
        if (this.sortAll) {
          this.$emit('changeSort', "1", null, null)
        }
      },
      sortChange(e){
        if (this.sortAll) {
          let sortRule;
          if(e.order=='descending'){
            sortRule = 'desc'
          }else if(e.order=='ascending') {
            sortRule = 'asc'
          }
          this.$emit('changeSort', "0", e.prop, sortRule)
          return
        }
         let hasSortData = this.tableDataFilter
         let tempDataFilter= [];
         let tableDataFilter=[];
          if (this.totalDown) {
            tempDataFilter= hasSortData.filter((v,k)=>k>=this.tableData.length - this.totalIsSum);
            tableDataFilter=hasSortData.filter((v,k)=>k< this.tableData.length - this.totalIsSum);
          } else {
            tempDataFilter= hasSortData.filter((v,k)=>k<this.totalIsSum);
            tableDataFilter=hasSortData.filter((v,k)=>k>=this.totalIsSum);
          }

          //将'-'替换成-999999放在最底部
          tableDataFilter = tableDataFilter.map(v=>{
            if(v[e.prop]=='-'){
              v[e.prop]= -999999
            }
            return v
          })

        console.log(this.type,'aaaaa')
        if(this.type == 'channelOnline'){
          //网销渠道所用排序
          let tmp = tableDataFilter.find(v => v.channelCode === 'sum')
          tableDataFilter = tableDataFilter.filter(v => v.channelCode !== 'sum')

          tableDataFilter.sort((a,b)=>{

            let aProp= parseFloat(a[e.prop])
            let bProp = parseFloat(b[e.prop])

            if(e.order=='descending'){
              return aProp - bProp;
            }else if(e.order=='ascending') {

              return bProp - aProp
            }
          })
          //排序完成后换回来
          tableDataFilter = tableDataFilter.map(v=>{
            if(v[e.prop]==-999999){
              v[e.prop]= '-'
            }
            return v
          })

          if(!!tmp){
            tableDataFilter.unshift(tmp)
          }

        }else{
          //其他报表所用排序
          tableDataFilter.sort((a,b)=>{

            let aProp= parseFloat(a[e.prop])
            let bProp = parseFloat(b[e.prop])

            if(e.order=='descending'){
              return aProp - bProp;
            }else if(e.order=='ascending') {

              return bProp - aProp
            }
          })
          //排序完成后换回来
          tableDataFilter = tableDataFilter.map(v=>{
            if(v[e.prop]==-999999){
              v[e.prop]= '-'
            }
            return v
          })
        }


        if (this.totalDown){
          this.tableDataFilter= tableDataFilter.concat(tempDataFilter)
        } else {
          this.tableDataFilter= tempDataFilter.concat(tableDataFilter)
        }

      },
      cellClick(row, column, cell, event){
        if(row.clickFn!==undefined){
          row.clickFn(row,column)
        }else{
          // alert('统计行不参与排序')
        }
      },
      filterIsSum(){
        // if(this.specialPath!='productionPlanSummarySheet'){
          let len = []
          len = this.tableData.filter(value=>value.isSum)
          if(len.length!=0){
            this.totalIsSum = len.length
          }else{
            this.totalIsSum = this.totalSpans
          }
        // }
      }
    },
    mounted(){
      let _this=this
      this.setAutoHeight()
      this.filterIsSum()
      window.addEventListener('resize',()=>{
        _this.setAutoHeight()
      })
    }
  }
</script>
<style lang="scss">
  .title-prop{
    background-color: #bfd9f9!important;
  }
  #app {
    #xj-table{
      .no-sort{
        padding-right: 6px;
      }
        .el-tooltip{
            font-size: 12px;
            color: #666;
        }
      #headset{
        position: absolute;
        z-index: 4;
        height: 30px;
        left: 30px;
        top:12px;
        text-align: center;
        line-height: 30px;
        >span{
          font-size: 13px;
        }

        .el-select{
          background-color: #f6f7fa;
          border-radius: 4px;
          line-height: 30px;
          margin-top: 5px;
          .el-input{
            line-height: 30px;
          }
        }
        .el-input--suffix .el-input__inner{
          font-size: 13px;
          line-height: 30px;
          height: 30px;
          border: none;
          background-color: #f6f7fa;
          text-align: center;
          /*.el-input{*/
            /*padding-left: 0px;*/
          /*}*/
        }
      }
      padding-left: 24px;
      padding-right: 18px;
      .el-table .sort-caret{
        border-width: 4px;
      }
      .el-table .sort-caret.ascending{
        top:7px;
      }
      .el-table .sort-caret.descending{
        bottom: 9px;
      }

      text-align: right;
      .el-table--border{
        border: none;
      }
      .el-table__fixed-right::before, .el-table__fixed::before, .el-table::before,.el-table--border::after, .el-table--group::after{
        display: none;
      }
      .el-table tr.table-row-color .cell,.special-table-row-color .cell{
        background-color: #e4ecf7!important;
        font-size: 13px;
      }
      .el-table th{
        background-color: transparent;
        border: none!important;
      }
      .is-group{
        tr:nth-of-type(2){
          th:first-of-type{
            .cell{
              text-align: center;
            }
          }
        }
        tr:first-of-type{
          th{
            height: 37px;
            .cell{
              background-color: #f6f7fa;
              line-height: 37px;
              height: 37px;
              color: #6CA0F5;
              text-align: center;
              position: relative;
              &::before {
                position: absolute;
                content: '';
                border-width: 16px 5px;
                border-style: solid;
                left: 0;
                top: 0px;
                border-color: white transparent transparent white;
              }
              &::after {
                position: absolute;
                content: '';
                border-width: 16px 5px;
                border-style: solid;
                right: 0;
                top: 0px;
                border-color: #fff #fff transparent transparent;
              }
            }
            &:nth-of-type(even){
              .cell{
                background-color: #eef1f5;
              }

            }
            &:first-of-type:not(.title-label){
              .cell{
                background-color: transparent;
                &::before,&::after{
                  display: none;
                }
              }
            }
          }
        }
      }
      .el-table .el-table__row.hover-row >td{
        background-color: transparent;
      }
      .cell{
        text-align: center;
        font-size: 13px;

        color: #666666;
      }
      .wb{
        color: #111111;
      }
      .special-table-row-color .wb ,tbody tr td .totolerow{
        color: #AE0000;
        font-weight:600;
      }
      tbody tr td .totolerow-index{
        min-width:30px;
        line-height:22px;
        background:#e7e8ea;
        border-radius:0px 11px 11px 0px;
        text-align: center;
        display: inline-block;
        padding:0  10px;
        position: relative;
        left: -10px;
        &.toptotolerow0{
          background-color: #F65177;
          color: #fff;
        }
        &.toptotolerow1{
          background-color: #F59E10;
          color: #fff;
        }
        &.toptotolerow2{
          background-color: #5093E1;
          color: #fff;
        }
      }
      /*tbody  tr:first-of-type {*/
        /*.first-row .cell span{*/
          /*border: 1px solid;*/
          /*padding: 1px 4px;*/
        /*}*/
      /*}*/
      /*tbody  tr:last-of-type {*/
        /*.last-row .cell span{*/
          /*border: 1px solid;*/
          /*padding: 1px 4px;*/
        /*}*/
      /*}*/
      tbody  tr td:first-of-type,th:first-of-type td{
        .cell{
          text-align: left;
        }
      }
      .el-table td{

        border: none;
        height: 37px;
        .cell{
          height: 33px;
          line-height: 33px;
          background-color: #F6F7FA;
          margin-bottom: 4px;
          padding-right: 6px;
          padding-left: 6px;
        }
      }
      /*定义分割线的样式，到时候会用js生成*/
      .el-table__body tr td.label-cell-border{
        >.cell{
          position: relative;
        }
        >.cell::before{
          position: absolute;
          left: 0;
          content: '';
          width: 1px;
          height: 21px;
          background-color: #DBDEE5;
          margin-top: 6px;
        }
      }
      /*定义隔列变色，会改成js实现*/
      .el-table__row {
        td.label-cell0{
          >.cell{
            background-color: #eef1f5;
          }

        }
      }
      .el-table__body tr td.cell-red{
        >.cell{
          color: #F65177;
        }
      }
      .el-table__body tr td.cell-blue{
        >.cell{
          color: #5093E1;
        }
      }
      .el-table__body tr td.cell-gold{
        >.cell{
          color: #F59E10;
        }
      }
      .el-table__body tr td.cell-purple{
        >.cell{
          color: #845de6;
        }
      }
      .el-table__body tr td.cell-click{
        >.cell{
          text-decoration: underline;
          cursor: pointer;
          &:hover{
            font-weight: bold;
          }
        }
      }
    .reset{
      background: #EBECF4;
      border-radius: 4px;
      line-height: 26px;
      padding: 4px 20px;
        font-size: 12px;
        color: #333;
        font-weight: normal;
      cursor: pointer;
      &:hover{
        background-color: #5093E1;
        color: #fff;
      }
    }

    }

  }

</style>
